import React from 'react';
import DocumentOpenManager from '../../managers/DocumentOpenManager';

const defaultDocumentOpenManager = new DocumentOpenManager();

class DocumentOpenLink extends React.Component {
  render() {
    const {
      source,
      className,
      label = 'VIZUALIZEAZA DOCUMENT',
      children,
      documentOpenManager = defaultDocumentOpenManager
    } = this.props;
    const url = documentOpenManager.resolveUrl(source);
    const content = children || label;

    if (!url) {
      return <span className={className}>{content}</span>;
    }

    return (
      <a
        className={className}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {content}
      </a>
    );
  }
}

export default DocumentOpenLink;
